import { EligibilityValidationMessageType } from '@app/enumerations';

export default class EligibilityValidationMessage {
	public sourceProcess: string | null = null;
	public sourceProcedure: string | null = null;
	public eligibilityName: string | null = null;
	public validationMessageType: EligibilityValidationMessageType | null = null;
	public userFriendlyDescription: string | null = null;
	public technicalDescription: string | null = null;

	public constructor() {

	}
};